<template>
  <div class="destinationPicker__info">
    <p>
      <span>
        {{ l('dreamPage.chart.information.intro') }}
      </span>
    </p>
    <br>
    <ul>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.cost_of_living.title') }}:</b> <span> {{ l('dreamPage.chart.information.cost_of_living.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://www.numbeo.com/cost-of-living/rankings_by_country.jsp"
        >
          <span>Numbeo</span>
        </BaseLink>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.safety.title') }}:</b> <span> {{ l('dreamPage.chart.information.safety.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://en.wikipedia.org/wiki/Global_Peace_Index"
        >
          <span>Wikipedia</span>
        </BaseLink><span>/Global Peace Index.</span>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.freedom.title') }}:</b> <span> {{ l('dreamPage.chart.information.freedom.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://freedomhouse.org/countries/freedom-world/scores"
        >
          <span>Freedom House</span>
        </BaseLink>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.guaranteed_sunshine.title') }}:</b> <span> {{ l('dreamPage.chart.information.guaranteed_sunshine.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://en.wikipedia.org/wiki/List_of_cities_by_sunshine_duration"
        >
          <span>Wikipedia</span>
        </BaseLink>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.corruption.title') }}:</b> <span> {{ l('dreamPage.chart.information.corruption.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://www.transparency.org/en/cpi/2022"
        >
          <span>Transparency International</span>
        </BaseLink>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.internet_connection.title') }}:</b> <span> {{ l('dreamPage.chart.information.internet_connection.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://worldpopulationreview.com/country-rankings/internet-speeds-by-country"
        >
          <span>World Population Review</span>
        </BaseLink>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.language_barriers.title') }}:</b> <span> {{ l('dreamPage.chart.information.language_barriers.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://en.wikipedia.org/wiki/EF_English_Proficiency_Index"
        >
          <span>Wikipedia</span>
        </BaseLink><span>/EF English Proficiency Index</span>
      </li>
      <li aria-level="1">
        <b>{{ l('dreamPage.chart.information.environmental_performance.title') }}:</b> <span>: {{ l('dreamPage.chart.information.environmental_performance.description') }} {{ l('dreamPage.chart.information.soruce') }} : </span><BaseLink
          target="_blank"
          href="https://epi.yale.edu/epi-results/2022/component/epi"
        >
          <span>EPI &ndash; Environmental Performance Index</span>
        </BaseLink>
      </li>
    </ul>
    <br>
    <p>
      <span>
        {{ l('dreamPage.chart.information.p1') }}
      </span>
    </p>
    <br>
    <p>
      <span>
        {{ l('dreamPage.chart.information.p2') }}
      </span>
    </p>
  </div>
</template>

<script setup>
// const { t } = useI18n();
import { l } from '@utils/toolbox';
</script>

<style scoped lang="scss">
/* text-[1.6rem] px-8 w-sm-100 w-md-33 */
.destinationPicker__info {
  color: #6e6e6e;

  font-size: 1.6rem;
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;

}
</style>
